import { render, staticRenderFns } from "./ShainSettei.vue?vue&type=template&id=5eed286a&scoped=true"
import script from "./ShainSettei.vue?vue&type=script&lang=js"
export * from "./ShainSettei.vue?vue&type=script&lang=js"
import style0 from "./ShainSettei.vue?vue&type=style&index=0&id=5eed286a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eed286a",
  null
  
)

export default component.exports